import { Component } from "react";
import { bindActionCreators } from 'redux';
import { triggerTransition } from '@uirouter/redux';
import { setAuthStarted } from '@/actions/auth'
import { setCheckoutOverlay } from "@/actions/ui";
import { reservationActive } from "@/selectors/reservation";
import { deleteReservation } from "@/actions/reservation";
import { connect } from "react-redux";
import Translation from '@s/Translation';

class AuthCloseButton extends Component {
  onCancel = () => {
    this.props.setAuthStarted(false);
    this.props.triggerTransition('ticketPicker');
    if (this.props.active) {
      this.props.deleteReservation();
    }
    this.props.setCheckoutOverlay(false);
  }

  render() {
    return (
      <button
        onClick={this.onCancel}
        className="button--secondary button--close">
        <i className="icon-close" aria-hidden="true"></i><span className="sr-only">
        <Translation>{'checkout__close'}</Translation></span>
      </button>
    )
  }
}


const mapStateToProps = (state) => {
  return {
    active: reservationActive(state),
  }
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    deleteReservation,
    setAuthStarted,
    setCheckoutOverlay,
    triggerTransition
  }, dispatch);
};

AuthCloseButton.propTypes = {};

export default connect(mapStateToProps, mapDispatchToProps)(AuthCloseButton)